export default __webpack_public_path__ + "static/media/piebald.f2493717.png";